module.exports = __webpack_public_path__ + "static/media/main_icon_highperformance.6bdf7764.svg";